module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate-new/design-tile-images/design-tile-20-bc5ab7e799a6033598fabcb6531f7ff0.jpg";